const ALLOWED_HOSTS = new Set(["youtube.com", "www.youtube.com", "m.youtube.com", "youtu.be", "music.youtube.com"]);

/**
 * Lightweight client-side sanity check mirroring the accepted URL shapes in spec §3.1.
 * The server remains authoritative (INVALID_URL / PLAYLIST_URL) — this only gives
 * fast inline feedback before a round trip.
 */
export function looksLikeYoutubeUrl(input: string): boolean {
  const trimmed = input.trim();
  if (!trimmed) return false;
  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return false;
  }
  if (!ALLOWED_HOSTS.has(url.hostname.toLowerCase())) return false;
  if (url.hostname.toLowerCase() === "youtu.be") {
    return /^\/[A-Za-z0-9_-]{11}/.test(url.pathname);
  }
  if (/^\/(shorts|live|embed)\/[A-Za-z0-9_-]{11}/.test(url.pathname)) return true;
  if (url.pathname === "/watch" && (url.searchParams.get("v") ?? "").length >= 11) return true;
  return false;
}
